var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewBadge = function SvgNewBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 22,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 22,
    fill: "#FFDBC7",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    d: "M15.927 6.6v5.124l-3.6-5.124h-1.26V15h1.656V9.864l3.6 5.136h1.26V6.6zm4.87 6.816v-1.884h3.18v-1.56h-3.18V8.184h3.48V6.6h-5.136V15h5.196v-1.584zM27.257 15h1.884l1.572-5.544L32.297 15h1.884l2.352-8.4h-1.74l-1.608 6.228L31.42 6.6h-1.416l-1.752 6.228L26.645 6.6h-1.74z"
  })));
};
export default SvgNewBadge;